// src/components/salaryCalculator/Visualisations/SalaryCalculator/TaxVisualisation.jsx
import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { lightColours, darkColours } from '../../../../styles/colours';
import NationalInsuranceBar from '../SalaryCalculator/NationalInsuranceBar';
import { TaxBracketView } from './TaxBracketView';

const TaxVisualization = ({
  bracketDetails,
  maxSalary,
  salary,
  nationalInsurance,
  taxableIncome,
  taxBands,
  darkMode,
}) => { 
  const TAX_BANDS = taxBands;
  const effectiveIncome =
  taxableIncome !== undefined && taxableIncome < salary ? salary : (taxableIncome !== undefined ? taxableIncome : salary);
  const currentBracketIndex = TAX_BANDS.findIndex((band) => effectiveIncome <= band.max);


  return (
    <Paper elevation={0} sx={{ p: 0, mt: 4, mb: 8, border: 'none', boxShadow: 'none' }}>
      {/* Explanation Box */}
      <Box
        sx={{
          p: 2,
          backgroundColor: darkMode ? '#333' : '#f9f9f9',
          mb: 3,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: darkMode ? '#fff' : '#333',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          How to read this chart:
        </Typography>

        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Typography
            variant="body2"
            sx={{
              color: darkColours.darkPink,
              display: 'inline',
              fontWeight: 'bold',
            }}
          >
            Top Bar
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: darkMode ? '#fff' : '#555',
              display: 'inline',
              ml: 0.5,
            }}
          >
            displays your <strong>National Insurance contributions</strong>
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center', mt: 0 }}>
          <Typography
            variant="body2"
            sx={{
              color: lightColours.midBlue,
              display: 'inline',
              fontWeight: 'bold',
            }}
          >
            Light Blue
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: darkMode ? '#fff' : '#555',
              display: 'inline',
              ml: 0.5,
            }}
          >
            displays the <strong>take-home pay</strong> for the tax bracket
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center', mt: 0 }}>
          <Typography
            variant="body2"
            sx={{
              color: lightColours.darkBlue,
              display: 'inline',
              fontWeight: 'bold',
            }}
          >
            Dark Blue
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: darkMode ? '#fff' : '#555',
              display: 'inline',
              ml: 0.5,
            }}
          >
            displays the <strong>tax deductions</strong> for the tax bracket
          </Typography>
        </Box>
      </Box>


      {/* National Insurance */}
      <div>
      <NationalInsuranceBar nationalInsurance={nationalInsurance} salary={salary} darkMode={darkMode} />
      </div>

      {/* New Tax Brackets */}
      <TaxBracketView bracketDetails={bracketDetails} TAX_BANDS={taxBands} maxSalary={maxSalary} darkMode={darkMode} currentBracketIndex={currentBracketIndex} />

    </Paper>
  );
}

export default TaxVisualization;
